export const CHANGE_FONT_SIZE = "CHANGE_FONT_SIZE";
export const CHANGE_THEME = "CHANGE_THEME";
export const GET_THEMES = "GET_THEMES";
export const SELECT_THEME = "SELECT_THEME";
